import { getBillLibraryChapterTree, getBillLibraryList } from "@/api/baseInventory"
import { getGovermentTemplateItemList, getGovernmentTemplateLibList, getTemplateDetail, getTemplateRelationList } from "@/api/governmentTemplate"
import useMemoizedFns from "@/hooks/useMemoizedFns"
import { sleep, uniq, isNotUndefined, isTimestamp, getStorage } from "@/utils/tools"
import { arrayToTree, traverseTree } from "@/utils/tree"
import { loadJsonFile } from "@/utils/report"
import { message } from "antd"
import { getReplacedProtocolHttp } from "@/utils/url"
import useStore from "@/pages/documentCompile/store/useStore"
import { EDITOR_ID } from ".."
import { DomainFieldConfig, FieldType, DocumentFileType } from "@/pages/documentCompile/type"
import { insertCheckboxSdt, insertDateSdt, insertDropdownSdt, insertImageSdt, insertTextSdt } from "../core/fieldInsert"
import { getOnlyOfficeConfig, syncProjectField } from "@/pages/documentCompile/api/onlyoffice"
import { downloadFile } from '@/utils/file'
import { getUrl } from '@/utils/request'

import { getCurrentEditor, saveDocument } from "../utils"
import { getArrayFromArrayString } from "@/utils/arr"
import dayjs from "dayjs"
import { isUndefined } from "lodash-es"
import { useSearchParams } from "react-router-dom"
import { getViewsFolderByViewId, updateProjectDocJuan } from "../../api/data-project-view"
import { getPackFolderTreeDataByRes } from "../utils/field"
import { confirmWithThreeButtons } from "@/utils/antd-help"
import { exportDoc, updateProjectDoc } from "@/pages/documentCompile/api/data-project-doc"
import { exportTaskManager } from "@/utils/exportTaskManager"
import { isLegalPreviewFileType } from "@/pages/documentCompile/utils/file"
import { DOC_URL, EXCEL_URL } from "../config/sysConfig"
import useInitData from "./useInitData"

export default function useMethods() {
  const setState = useStore.setState
  const [searchParams] = useSearchParams();
  const requestId = searchParams.get('requestId')

  const { refreshPackageFolderTreeData, initDomainSettingData } = useInitData()
  const handleMessage = async (event: any) => {
    const isEditMode = useStore.getState().isEditMode
    const allDomainTagMap = useStore.getState().allDomainTagMap
    const data = event.data;
    if (data.type !== "documentDblClick") return;
    // await sleep(1000)
    const editor = getCurrentEditor();
    if (!editor) return;
    const connector = editor.createConnector();
    // 将 domainConfig 存入 Asc.scope
    window.Asc.scope.allDomainTagMap = allDomainTagMap;
    connector.callCommand(
      () => {
        const allDomainTagMap = Asc.scope.allDomainTagMap;
        let oDocument = Api.GetDocument();
        let oCurrentContentControl = oDocument.GetCurrentContentControl();
        console.log("oCurrentContentControl", oCurrentContentControl)
        let result = null

        if (oCurrentContentControl) {
          const tag = oCurrentContentControl.GetTag();
          if (tag) {
            result = tag?.split('@')[0]
          }
        }
        // 返回结果给外部
        return result;
      },
      (result) => {
        console.log("result", result)
        const fieldConfig = allDomainTagMap[result]
        if (!isEditMode) return;
        if (!fieldConfig) return;
        setState({ domainFieldTypeModalVisible: true, clickedFieldInfo: fieldConfig })
      }
    );
  };

  // 插入域到文档（统一处理，只插入黄色标记的段落）
  const insertFieldToDocument = (
    fieldConfig: DomainFieldConfig,
    value?: any
  ) => {
    // const documentReady = useStore.getState().documentReady
    // if (!documentReady) {
    //   message.warning("文档尚未就绪，请稍后再试")
    //   return;
    // }
    const editor = window.DocEditor?.instances[EDITOR_ID];
    if (!editor) {
      message.error("编辑器未准备就绪");
      return;
    }
    const connector = editor.createConnector();
    // 文本域
    if (
      fieldConfig.fieldType === FieldType.SHORT_TEXT ||
      fieldConfig.fieldType === FieldType.LONG_TEXT ||
      fieldConfig.fieldType === FieldType.SYSTEM_COMPANY ||
      fieldConfig.fieldType === FieldType.SYSTEM_PERSON
    ) {
      insertTextSdt(connector, fieldConfig, value);
      return;
    }
    if (fieldConfig.fieldType === FieldType.DROPDOWN) {
      insertDropdownSdt(connector, fieldConfig, value);
      return;
    }
    if (
      fieldConfig.fieldType === FieldType.CHECKBOX ||
      fieldConfig.fieldType === FieldType.SINGLE_CHECKBOX
    ) {
      insertCheckboxSdt(connector, fieldConfig, value);
      return;
    }
    if (fieldConfig.fieldType === FieldType.IMAGE) {
      insertImageSdt(connector, fieldConfig, value);
      return;
    }
    if (
      fieldConfig.fieldType === FieldType.DATE_LONG ||
      fieldConfig.fieldType === FieldType.DATE_SHORT
    ) {
      insertDateSdt(connector, fieldConfig, value);

    }

  };

  // 处理字段双击 - 插入域到文档（带当前设置的值）
  const handleFieldDoubleClick = (
    fieldConfig: DomainFieldConfig,
    currentValue?: any
  ) => {
    // console.log("双击字段:", fieldConfig, "当前值:", currentValue);
    const editor = window.DocEditor?.instances[EDITOR_ID];
    if (!editor) {
      message.error("编辑器未准备就绪");
      return;
    }
    try {
      // 统一插入域（不区分类型）
      insertFieldToDocument(fieldConfig, currentValue);

      // 显示当前值信息
      let displayValue = currentValue;
      if (currentValue && fieldConfig.content?.options) {
        const selectedOption = fieldConfig.content?.options.find(
          (opt) => opt.value === currentValue
        );
        displayValue = selectedOption ? selectedOption.label : currentValue;
      }

      message.success(
        `成功插入域: ${fieldConfig.fieldName}${displayValue ? ` (值: ${displayValue})` : ""
        }`
      );
    } catch (error) {
      console.error("插入域失败:", error);
      message.error("插入域失败");
    }
  };

  // 处理域点击（用于实现弹框功能）
  const handleFieldClick = (fieldKey: string, fieldInfo: any) => {
    console.log("域被点击:", fieldKey, fieldInfo);
    // // 查找对应的域配置信息（通过 fieldId 或 fieldName 查找）
    // let foundFieldConfig = null;
    // let foundFieldId = "";

    // // 首先尝试通过 fieldId 查找
    // if (fieldInfo.fieldId) {
    //   for (const group of domainConfig) {
    //     const field = group.fields.find((f) => f.fieldName === fieldInfo.fieldId);
    //     if (field) {
    //       foundFieldConfig = field;
    //       foundFieldId = field.fieldName;
    //       break;
    //     }
    //   }
    // }

    // // 如果没找到，尝试通过 fieldName 查找
    // if (!foundFieldConfig && (fieldKey || fieldInfo.fieldName)) {
    //   const searchName = fieldKey || fieldInfo.fieldName;
    //   for (const group of domainConfig) {
    //     const field = group.fields.find((f) => f.fieldName === searchName);
    //     if (field) {
    //       foundFieldConfig = field;
    //       foundFieldId = field.fieldName;
    //       break;
    //     }
    //   }
    // }

    // if (foundFieldConfig) {
    //   // 组合完整的域信息
    //   const completeFieldInfo = {
    //     ...fieldInfo,
    //     config: foundFieldConfig,
    //     fieldId: foundFieldId,
    //     currentValue: fieldValues[foundFieldId] || fieldInfo.fieldValue,
    //     groupName:
    //       domainConfig.find((g) => g.fields.some((f) => f.fieldName === foundFieldId))
    //         ?.fieldName || "未知分组",
    //   };

    //   setClickedFieldInfo(completeFieldInfo);
    //   setIsFieldModalVisible(true);
    // } else {
    //   message.warning(
    //     `未找到域配置信息: ${fieldKey || fieldInfo.fieldName || "未知"}`
    //   );
    // }
  };

  const handleAsyncReplaceFieldValue = async () => {
    const editorConfig = useStore.getState().editorConfigBack
    const allDomainTagMap = useStore.getState().allDomainTagMap
    const selectedFileData = useStore.getState().selectedFileData
    const settingDomainFormData = useStore.getState().settingDomainFormData
    const settingProjectFormData = useStore.getState().settingProjectFormData
    const usedDomainDocDataMap = useStore.getState().usedDomainDocDataMap
    const signFormData = useStore.getState().signFormData
    const allFormData = {
      ...settingDomainFormData,
      ...settingProjectFormData
    }
    const submitFormData = { ...allFormData }
    // const submitFormData = {
    // }
    // Object.keys(allFormData).forEach(key => {
    //   if (usedDomainDocDataMap[key]) {
    //     submitFormData[key] = allFormData[key]
    //   }
    // })
    // 签明域
    Object.keys(signFormData || {}).forEach(key => {
      const value = signFormData[key]
      //  签名加上#号
      // if (value.sign) {
      //   value.sign = value?.sign?.startsWith('#') ? value.sign : ('#' + value.sign)
      // }
      if (value.picFileKey) {
        submitFormData[key] = value
      }
    })
    // 设置需要加载域配置
    setState({ needLoadDomainConfig: true })
    // 构造同步数据
    // const filterFormData = filterSubmitSettingFieldValue(allFormData)
    // 只提交当前文档中用到的
    const filterFormData = filterSubmitSettingFieldValue(submitFormData)
    const syncData = Object.keys(filterFormData).map(fieldName => {
      // if (fieldName === 'sign') {
      //   filterFormData[fieldName] = filterFormData[fieldName]?.sign?.startsWith('#') ? filterFormData[fieldName].sign : ('#' + filterFormData[fieldName].sign)
      // }
      return ({
        fieldId: editorConfig?.document?.key,
        fieldTag: allDomainTagMap[fieldName]?.fieldTag || fieldName,
        fieldName: allDomainTagMap[fieldName]?.fieldName || fieldName,
        fieldValue: filterFormData[fieldName],
        projectId: selectedFileData.projectId || 0,
        docId: selectedFileData.id || 0
      })
    });
    try {
      await syncProjectField(selectedFileData.id, syncData);
    } catch (error) {
      // 如果同步失败，将状态设置回 false
      setState({ needLoadDomainConfig: false })
      throw error;
    }
  }

  // 处理表单值的转换和格式化
  const handleFormValue = (formValue: any, fieldKey?: string) => {
    const arrayValue = getArrayFromArrayString(formValue, { needNumber: true })

    // 如果提供了 fieldKey，进行额外的字段类型处理
    if (fieldKey) {
      const allDomainTagMap = useStore.getState().allDomainTagMap
      const fieldItem = allDomainTagMap[fieldKey]
      if (fieldItem &&
        [FieldType.CHECKBOX, FieldType.SINGLE_CHECKBOX, FieldType.DROPDOWN].includes(fieldItem.fieldType) &&
        isNotUndefined(arrayValue) &&
        arrayValue !== ''
      ) {
        return Array.isArray(arrayValue) ? arrayValue.map(i => Number(i)) : Number(arrayValue)
      }
    }

    return arrayValue
  }

  // 处理整个表单数据的转换
  const processFormData = (formData: any) => {
    if (!formData || Object.keys(formData).length === 0) {
      return formData
    }

    const processedData = { ...formData }
    Object.keys(processedData).forEach(key => {
      processedData[key] = handleFormValue(processedData[key], key)
    })

    return processedData
  }

  // 过滤提交的表单数据 - 处理 dayjs 对象并过滤空值
  const filterSubmitSettingFieldValue = (formData: any) => {
    const newFormData = {}
    Object.keys(formData).map(fieldName => {
      let fieldValue = formData[fieldName]
      if (dayjs.isDayjs(fieldValue)) {
        fieldValue = String(fieldValue.valueOf());
      }
      // 允许为空
      newFormData[fieldName] = fieldValue
      // if (!isUndefined(fieldValue) && fieldValue !== '') {
      //   newFormData[fieldName] = fieldValue
      // }
    })
    return newFormData
  }

  // 获取 Antd 表单数据 - 将时间戳转换为 dayjs 对象
  const getAntdFormData = (formData: any) => {
    const newFormData = {}
    Object.keys(formData).map(key => {
      let fieldValue = formData[key] || ''
      if (isTimestamp(fieldValue)) {
        fieldValue = dayjs(Number(fieldValue))
      }
      newFormData[key] = fieldValue
    })
    return newFormData
  }

  // 异步更新表单数据 - 根据字段子字符串和选中项更新相关字段
  const asyncFormData = (parentId: string, selectItem: any) => {
    const settingDomainFormData = useStore.getState().settingDomainFormData
    const latestAllDomainTagMap = useStore.getState().allDomainTagMap
    const newValues = { ...settingDomainFormData }
    const changeValues = {}
    Object.keys(latestAllDomainTagMap).forEach(key => {
      const item = latestAllDomainTagMap[key]
      if (item.parentId === parentId) {
        const columnField = item.fieldValue
        changeValues[key] = selectItem[`attr_${columnField}`]
      }
    })

    // 更新状态
    setState({
      settingDomainFormData: {
        ...newValues,
        ...changeValues
      },
    });

    // 返回变更的值，供组件使用
    return changeValues
  }

  // 替换文档域值
  const doReplaceFieldValue = () => {
    const allDomainTagMap = useStore.getState().allDomainTagMap
    const currentSettingDomainFormData = useStore.getState().settingDomainFormData
    const currentSettingProjectFormData = useStore.getState().settingProjectFormData
    const usedDomainDocDataMap = useStore.getState().usedDomainDocDataMap
    // 合并表单数据
    const allFormData = {
      ...currentSettingDomainFormData,
      ...currentSettingProjectFormData
    }

    // 过滤数据 - 只保留有值的字段
    const filteredFormData = {}
    Object.keys(allFormData).forEach(key => {
      const fieldValue = allFormData[key]
      // 只要被使用过，都收集
      // if (isNotUndefined(fieldValue) && fieldValue !== '' && !usedDomainDataMap[key]) {
      if (usedDomainDocDataMap[key]) {
        filteredFormData[key] = fieldValue
      }
    })
    console.log("替换域值", allFormData, filteredFormData, usedDomainDocDataMap);
    const editor = window.DocEditor?.instances[EDITOR_ID];
    if (!editor) return;
    const connector = editor.createConnector();
    if (!connector) return;
    if (Object.keys(filteredFormData).length === 0) return;

    window.Asc.scope.formValues = filteredFormData;
    window.Asc.scope.allDomainTagMap = allDomainTagMap;
    // console.log("allDomainTagMap", allDomainTagMap, Object.keys(allDomainTagMap));
    connector.callCommand(() => {
      const formValues = Asc.scope.formValues;
      const allDomainTagMap = Asc.scope.allDomainTagMap;
      let doc = Api.GetDocument();
      let allElements = doc.GetAllContentControls(); // 获取文档中所有内容控件
      console.log("allElements", allElements.length);
      for (let i = 0; i < allElements.length; i++) {
        let sdt = allElements[i];
        const tag = sdt.GetTag();
        const checkboxValue = tag.slice(-1)
        const tagFix = tag.split('@')[0]
        const formValue = formValues[tagFix]
        const domainConfig = allDomainTagMap[tagFix]
        if (domainConfig?.fieldType === 'dx') {
          if (tagFix === domainConfig?.fieldTag) {
            sdt.SetCheckBoxChecked(formValue == checkboxValue)
          }
        } else if (domainConfig?.fieldType === 'fx') {
          const formValues = (formValue || []).map(i => String(i))
          sdt.SetCheckBoxChecked(formValues.includes(checkboxValue))
        } else if (domainConfig?.fieldType === 'lb') {
          sdt.SelectListItem(String(formValue))
        } else if (['crq', 'drq'].includes(domainConfig?.fieldType)) {
          // formValue 已经在前面处理过，确保是 Date 对象

          sdt.SetDate(formValue instanceof Date ? formValue : new Date(formValue?.valueOf()))
        } else {
          if (typeof (formValue) !== 'undefined') {
            sdt.RemoveAllElements();
            let newRun = Api.CreateRun();
            console.log("fff", { formValues, tagFix, domainConfig });
            const alias = domainConfig?.fieldName ? `$${domainConfig.fieldName}` : ''
            const text = formValues[tagFix].toString() || alias
            newRun.AddText(text);
            sdt.AddElement(newRun, 0);
          }
        }
      }
    });
  }


  interface GenerateEditorConfigParams {
    fileUrl: any
    fileName: any
    token?: any
  }
  const generateEditorConfig = async ({
    fileUrl,
    fileName,
    token,  // 默认为查看模式
  }: GenerateEditorConfigParams) => {
    const mode = useStore.getState().isEditMode ? 'edit' : 'view'
    try {
      const res = await getOnlyOfficeConfig({
        fileUrl,
        fileName: fileName,
      })

      const data = res || {}

      data.height = `100%`

      if (!data.editorConfig.customization) {
        data.editorConfig.customization = {}
      }

      // 设置编辑模式
      data.editorConfig.mode = mode;

      data.editorConfig.customization = {
        ...data.editorConfig.customization,
        uiTheme: "theme-white",
        about: false,
        layout: {
          toolbar: {
            file: {
              info: false,
            },
          },
        },
        forcesave: true,
        features: {
          spellcheck: false,
        },
        compactToolbar: true,
        anonymous: {
          request: false,
          label: "Guest",
        },
        compactHeader: true,
        comments: false,
        hideRulers: true,
        chat: false,
      }

      data.editorConfig.plugins = {
        autostart: [],
        pluginsData: [],
        options: {
          all: { token },
        },
      }

      return data
    } catch (error) {
      console.error('generateEditorConfig error:', error)
      throw error
    }
  }

  // 导出文档
  const handleExport = async (params: {
    convertToPdf: boolean;
    folderIds?: React.Key[];
    projectId: string | number;
    docIds?: React.Key[];
    viewId?: string;
  }) => {
    try {
      const res = await exportDoc(params)
      // res 格式： {
      //   "exportKey": "-515554543",
      //   "fileName": "测试导出-导出文件-20250818171201.zip"
      // }
      console.log("导出文档", res);

      if (res && res.exportKey && res.fileName) {
        // 添加到导出任务管理器
        const taskId = exportTaskManager.addTask(res.exportKey, res.fileName, params.projectId);
        console.log("已添加导出任务:", taskId);
        message.success(`导出任务已启动，文件：${res.fileName}`);
      } else {
        message.error('导出响应格式异常');
      }
    } catch (error) {
      message.error('导出失败');
      console.error('导出失败:', error);
      throw error;
    }
  };

  // 刷新视图
  const refreshView = async (folder) => {
    const projectId = searchParams.get('projectId');
    // const currentDetailFolder =  useStore.getState().currentDetailFolder
    const folderViewId = folder.viewId.toString()

    const promiseList = [
      getViewsFolderByViewId(projectId, folderViewId),
    ]
    const [viewRes,] = await Promise.all(promiseList)
    const newViewRes = viewRes.map(item => {
      return {
        ...item,
        viewId: folderViewId,
      }
    })
    const folderList = useStore.getState().folderList
    const { tree: packageFolderTreeData, expandKey: packageFolderTreeDataExpandedKeys, firstFileNode } = getPackFolderTreeDataByRes(newViewRes, folderList)
    if (!firstFileNode) {
      message.warning("没有可预览的文档")
      return
    }
    // 兼容卷目录问题
    if (firstFileNode.isJuan && !firstFileNode.docUrl) {
      firstFileNode.docUrl = DOC_URL
    }
    setState({
      currentSettingDetailFolderDoc: folder,
    });
    // setState({
    //   packageFolderTreeData: packageFolderTreeData,
    //   packageFolderTreeDataExpandedKeys: packageFolderTreeDataExpandedKeys as any[]
    // })
    // 传递viewRes给handlePackageFolderClick，避免重复调用接口
    handlePackageFolderClick(firstFileNode, newViewRes)
  }

  // 处理资料包目录点击
  const handlePackageFolderClick = async (node: any, viewRes?: any[]) => {
    const documentReady = useStore.getState().documentReady
    if (!documentReady) {
      message.warning('等待文档加载完成...', 1);
      return;
    }
    if (node.disabled) return;
    // const packageFolderTreeData = useStore.getState().packageFolderTreeData
    // console.log("packageFolderTreeData", packageFolderTreeData)
    const latestDocumentSettingProjectData = useStore.getState().documentSettingProjectData
    const isOnlyOfficeDocumentModified = useStore.getState().isOnlyOfficeDocumentModified
    const editorConfig = useStore.getState().editorConfigBack
    const selectedFileData = useStore.getState().selectedFileData
    const documentSettingProjectData = useStore.getState().documentSettingProjectData
    const fileName = node.fileName || node.documentName || node.name
    const fileUrl = node.docUrl
    const storeFileUrl = latestDocumentSettingProjectData.documentDetail?.docUrl
    const storeFileId = latestDocumentSettingProjectData.documentDetail?.id
    if (!fileUrl && !storeFileUrl) {
      return;
    }
    // if (storeFileUrl && fileUrl && storeFileUrl === fileUrl) {
    //   return;
    // }
    // 
    if (storeFileId && node.id === storeFileId) {
      return;
    }
    if (!isLegalPreviewFileType(fileName)) {
      message.warning('该文件类型不支持预览');
      return;
    }

    const setUnSaveStoreState = () => {
      // 切换文档
      setState({
        selectedFileData: { ...node },
        isOnlyOfficeDocumentModified: false,
        documentLoading: false,
        documentSettingProjectData: {
          ...latestDocumentSettingProjectData,
          documentDetail: { ...node },
        }
      });
    }

    // 如果是文件夹，不做任何处理
    if (node.folder) {
      return;
    }
    // 如果文件改动了，弹出确认框
    if (isOnlyOfficeDocumentModified) {
      const result = await confirmWithThreeButtons({
        title: '文档已修改',
        content: '是否需要保存更改？',
      });

      if (result === 'cancel') {
        return;
      }
      if (result === 'noSave') {
        setUnSaveStoreState()
      }

      if (result === 'ok') {
        setState({
          editorConfigLoading: true,
        });
        // console.log("saveDocument", { editorConfig, selectedFileData, fileName, })
        const saveResult = await saveDocument({
          fileName: selectedFileData.fileName || selectedFileData.documentName || '文档',
          editorConfig: editorConfig,
          showMessage: false, // 不显示保存成功消息
        });
        if (!saveResult.modify) {
          message.warning("文档未修改");
          setState({
            editorConfigLoading: false,
          });
          return;
        }
        if (!saveResult.success) {
          message.error("保存文档失败，无法进行同步");
          setState({
            editorConfigLoading: false,
          });
          return;
        }

        const docName = latestDocumentSettingProjectData.documentDetail.fileName || latestDocumentSettingProjectData.documentDetail.documentName || latestDocumentSettingProjectData.documentDetail.name;
        const projectId = latestDocumentSettingProjectData.documentDetail.projectId
        try {
          if (selectedFileData.isJuan) {
            await updateProjectDocJuan({ viewId: node.viewId, docUrl: saveResult.fileUrl, }, requestId, projectId)
          } else {
            const params = {
              "docId": latestDocumentSettingProjectData.documentDetail.id,
              "docName": docName,
              "docUrl": saveResult.fileUrl,
              "projectId": projectId,
            };
            await updateProjectDoc(params, requestId);
          }
          message.success("保存成功");
          setState({
            editorConfigLoading: false,
            isOnlyOfficeDocumentModified: false,
            selectedFileData: { ...node },
            documentSettingProjectData: {
              ...documentSettingProjectData,
              documentDetail: {
                ...node,
              }
            }
          });
        } catch (error) {
          message.error("保存失败");
          setState({
            editorConfigLoading: false,
          });
        }
      }
    } else {
      // 切换文档
      setUnSaveStoreState()
    }
    // 如果已提供viewRes，使用它来避免重复调用接口
    if (viewRes) {
      refreshPackageFolderTreeData(viewRes)
    } else {
      refreshPackageFolderTreeData()
    }

    try {
      const hackGetFileUrl = (node: any) => {
        if (!node.docUrl) {
          if (node.type === 'word' || node.type === DocumentFileType.WORD) {
            return DOC_URL;
          }
          if (node.type === 'excel' || node.type === DocumentFileType.EXCEL) {
            return EXCEL_URL;
          }
        }
        return node.docUrl;
      };
      const queryParams = {
        fileUrl: hackGetFileUrl(node),
        fileName: node.name || 'document'
      };
      setState({ documentReady: false })
      const editorConfig = await generateEditorConfig(queryParams);
      if (editorConfig) {
        const editor = getCurrentEditor()
        // 判断配置的document.fileType 和 documentType 是否发生了变化
        const latestEditorConfig = useStore.getState().editorConfig
        // 启用刷新
        if (latestEditorConfig.document.fileType === editorConfig.document.fileType && latestEditorConfig.document.documentType === editorConfig.document.documentType) {
          console.log("refreshFile1", editorConfig)
          editor.refreshFile({ ...editorConfig })
          // editor.destroyEditor();
          setState({ documentReady: true });
          console.log("refreshFile2", editorConfig)
        } else {
          setState({ editorConfig });
        }
        // 禁用刷新，直接全部加载
        // setState({ editorConfig });
        setState({
          editorConfigBack: { ...editorConfig }
        })
      }
    } catch (error) {
      console.error('重新生成编辑器配置失败:', error);
    } finally {
      setState({ documentLoading: false });
    }
  }

  return useMemoizedFns({
    handleMessage,
    handleFieldDoubleClick,
    handleFieldClick,
    handleAsyncReplaceFieldValue,
    generateEditorConfig,
    handleFormValue,
    processFormData,
    asyncFormData,
    doReplaceFieldValue,
    filterSubmitSettingFieldValue,
    getAntdFormData,
    handleExport,
    refreshView,
    handlePackageFolderClick,
  })
}
